import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Crimson+Text:wght@400;600;700&display=swap');
  
  :root {
    --primary-color: #D4AF37; /* Champagne gold from logo */
    --secondary-color: #C9A961; /* Lighter gold */
    --accent-color: #F5F1E8; /* Warm cream accent */
    --background-dark: #FAFBFC; /* Very light gray background */
    --background-darker: #F0F2F5; /* Light gray sections */
    --background-lighter: #FFFFFF; /* White sections */
    --background-accent: #F5F1E8; /* Warm cream tinted background */
    --text-primary: #1A1A1A; /* Darker text for better contrast */
    --text-secondary: #4A4A4A; /* Medium gray text */
    --text-tertiary: #7A7A7A; /* Light gray text */
    --border-color: #E5E7EB; /* Subtle border */
    --success-color: #10B981;
    --error-color: #EF4444;
    --warning-color: #F59E0B;
    --border-radius: 20px;
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
    --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.12);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Crimson Text', 'Copperplate', 'Copperplate Gothic Light', Georgia, serif;
    background-color: var(--background-dark);
    color: var(--text-primary);
    line-height: 1.6;
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Crimson Text', 'Copperplate', 'Copperplate Gothic Light', Georgia, serif;
    font-weight: 700;
    letter-spacing: 1px;
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: var(--transition);
    
    &:hover {
      color: var(--secondary-color);
    }
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: var(--primary-color);
    color: var(--text-primary);
    padding: 10px 20px;
    border-radius: var(--border-radius);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    transition: var(--transition);
    
    &:hover {
      background: var(--secondary-color);
      transform: translateY(-2px) scale(1.02);
    }
    
    &:active {
      transform: translateY(0) scale(0.98);
    }
    
    &:disabled {
      background: var(--text-tertiary);
      cursor: not-allowed;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin-bottom: 1rem;
  }

  section {
    padding: 80px 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-title {
    text-align: center;
    margin-bottom: 50px;
    
    h2 {
      font-size: 2.5rem;
      color: var(--text-primary);
      position: relative;
      display: inline-block;
      
      &:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 70px;
        height: 3px;
        background: var(--primary-color);
      }
    }
    
    p {
      color: var(--text-secondary);
      font-size: 1.1rem;
      max-width: 600px;
      margin: 20px auto 0;
    }
  }

  /* Responsive styles */
  @media (max-width: 768px) {
    section {
      padding: 60px 0;
    }
    
    .section-title h2 {
      font-size: 2rem;
    }
  }
`;
